import { FC, SVGAttributes } from 'react';

const DescriptionImage: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M34.2998 15.7H69.2998C72.0998 15.7 74.2998 17.9 74.2998 20.7V63.7C74.2998 66.5 72.0998 68.7 69.2998 68.7H34.2998C31.4998 68.7 29.2998 66.5 29.2998 63.7V20.7C29.2998 18 31.4998 15.7 34.2998 15.7Z"
        fill="#F0F2F3"
      />
      <path d="M38.5 30H65.1" stroke="#3227A3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38.5 41.2H65.1" stroke="#3227A3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38.5 52.5H65.1" stroke="#3227A3" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M74.2997 59.5999V64.8999C74.2997 66.9999 72.5997 68.6999 70.4997 68.6999H65.1997L74.2997 59.5999Z" fill="#7B70F9" />
      <path d="M65.1997 68.6999V63.3999C65.1997 61.2999 66.8997 59.5999 68.9997 59.5999H74.2997L65.1997 68.6999Z" fill="#3227A3" />
      <path
        d="M34.1999 11H18.8999C16.0999 11 13.8999 13.2 13.8999 16V18.7C13.8999 21.5 16.0999 23.7 18.8999 23.7H31.8999L34.6999 26.5V23.7C37.2999 23.5 39.2999 21.3 39.2999 18.7V16C39.2999 13.2 36.9999 11 34.1999 11Z"
        fill="url(#paint0_linear_7800_26294)"
      />
      <path
        d="M20.8997 18.5C21.5624 18.5 22.0997 17.9627 22.0997 17.3C22.0997 16.6373 21.5624 16.1 20.8997 16.1C20.237 16.1 19.6997 16.6373 19.6997 17.3C19.6997 17.9627 20.237 18.5 20.8997 18.5Z"
        fill="white"
      />
      <path
        d="M26.4998 18.5C27.1625 18.5 27.6998 17.9627 27.6998 17.3C27.6998 16.6373 27.1625 16.1 26.4998 16.1C25.8371 16.1 25.2998 16.6373 25.2998 17.3C25.2998 17.9627 25.8371 18.5 26.4998 18.5Z"
        fill="white"
      />
      <path
        d="M32.0999 18.5C32.7626 18.5 33.2999 17.9627 33.2999 17.3C33.2999 16.6373 32.7626 16.1 32.0999 16.1C31.4372 16.1 30.8999 16.6373 30.8999 17.3C30.8999 17.9627 31.4372 18.5 32.0999 18.5Z"
        fill="white"
      />
      <path d="M13 43H5V51H13V43Z" fill="#7B70F9" />
      <path d="M21 51H13V59H21V51Z" fill="#978EF8" />
      <path d="M33.5 35H25.5V43H33.5V35Z" fill="#4939F3" />
      <defs>
        <linearGradient id="paint0_linear_7800_26294" x1="38.0999" y1="18.7148" x2="11.4699" y2="18.7148" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4939F3" />
          <stop offset="1" stopColor="#3227A3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DescriptionImage;
